import { EQUITY_HOLDING_LIVE_NEWS, LIVE_NEWS, LIVE_NEWS_ERROR, LIVE_NEWS_HIDE_ERROR, LIVE_NEWS_START_LOADER, LIVE_NEWS_STOP_LOADER, LIVE_NEWS_STREAM, QOUTE_STREAM_NEWS, RESET_STREAM_COUNT, } from "../interface/iLiveNewsReducer";
import store from "@frameworks/web/redux/store";
export default class LiveNewsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    resetCount() {
        this.dispatch({
            type: RESET_STREAM_COUNT,
        });
    }
    getNewsStreamData(payload) {
        this.dispatch({
            type: QOUTE_STREAM_NEWS,
            payload: { qouteStream: payload },
        });
    }
    getLiveNewsStreamData(payload) {
        this.dispatch({
            type: LIVE_NEWS_STREAM,
            payload: { liveNewsData: payload },
        });
    }
    getLiveNewsData(data) {
        this.dispatch({
            type: LIVE_NEWS,
            payload: { data },
        });
    }
    getEquityHoldingLiveNews(data) {
        this.dispatch({
            type: EQUITY_HOLDING_LIVE_NEWS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: LIVE_NEWS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: LIVE_NEWS_HIDE_ERROR,
        });
    }
    setStartLiveNewsLoader() {
        this.dispatch({
            type: LIVE_NEWS_START_LOADER,
        });
    }
    setStopLiveNewsLoader() {
        this.dispatch({
            type: LIVE_NEWS_STOP_LOADER,
        });
    }
}
